import global from "@godweb/frontend-base/src/store/global";
import Vue from "vue";
import Vuex from "vuex";
import video_popup from "./video_popup";

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    global,
    video_popup,
  },
});
export default store;
